<template>
  <div class="ovg-landing">
    <div class="ovg-landing__bg" aria-hidden="true" />

    <div class="ovg-landing__card">
      <img
        src="@/assets/logo_original.svg"
        alt="Samtek"
        class="ovg-landing__logo"
      />
      <h1 class="ovg-landing__title">
        Protección oficial para tu equipo<br />por más tiempo.
      </h1>
      <p class="ovg-landing__subtitle">
        Tranquilidad total para tu dispositivo Samtek.<br />
        Extiende tu garantía oficial en pocos pasos y protégelo contra
        imprevistos.
      </p>
      <button class="ovg-btn ovg-btn--primary ovg-landing__cta" @click="start">
        Empezar Solicitud
      </button>
    </div>

    <p class="ovg-landing__footer">
      © 2026 Samtek | Servicio Técnico ASUS Autorizado en Chile.
    </p>
  </div>
</template>

<script>
export default {
  name: 'LandingView',
  methods: {
    start() {
      this.$router.push({ name: 'ovg-cliente' })
    },
  },
}
</script>

<style scoped>
.ovg-landing {
  font-family: 'Noto Sans', sans-serif;
  min-height: 100vh;
  background-color: #f5f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 40px 20px;
}

.ovg-landing__bg {
  /* Sin `opacity`: el PNG ya es una marca de agua (su patrón viene con
     alpha 13/255). Desvanecerlo otra vez acá lo dejaba en 0,62% de
     contraste, o sea invisible en pantalla. */
  position: absolute;
  inset: 0;
  background-image: url('~@/assets/fondo_samtek.png');
  background-size: cover;
  background-position: center;
  pointer-events: none;
}

.ovg-landing__card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 16px;
  padding: 40px;
  width: 700px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.ovg-landing__logo {
  width: 329px;
  max-width: 100%;
}

.ovg-landing__title {
  font-size: 28px;
  font-weight: 700;
  color: #23201c;
  text-align: center;
  margin: 0;
  line-height: 1.3;
}

.ovg-landing__subtitle {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

.ovg-landing__cta {
  width: 550px;
  max-width: 100%;
}

.ovg-landing__footer {
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 0;
  z-index: 1;
  font-size: 15px;
  font-weight: 400;
  color: #23201c;
  text-align: center;
  margin: 0;
  padding: 0;
  border: none;
}

/* Shared button styles (also used in child views via deep selector) */
.ovg-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s;
}

.ovg-btn:hover {
  opacity: 0.9;
}

.ovg-btn--primary {
  background: #fece2f;
  color: #23201c;
}

.ovg-btn--secondary {
  background: #f5f6fa;
  color: #23201c;
}

/* ============================================================
   MOBILE — max-width: 767px
   ============================================================ */
@media (max-width: 767px) {
  .ovg-landing {
    padding: 24px 16px 40px;
  }

  .ovg-landing__card {
    width: calc(100% - 32px);
    max-width: 375px;
    padding: 24px 20px;
    gap: 20px;
  }

  .ovg-landing__logo {
    width: 200px;
  }

  .ovg-landing__title {
    font-size: 24px;
  }

  .ovg-landing__subtitle {
    font-size: 14px;
  }

  .ovg-landing__cta {
    width: 100%;
    background: #203859;
    color: #ffffff;
  }

  .ovg-landing__footer {
    position: static;
    margin-top: 24px;
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>
